import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // our index route just redirects to the login page (to check the auth state of the user)
    throw redirect({ to: '/login' })
  },
})
